export default {
  table: {
    columns: 'Columns'
  }
};
